import { useProtocolStore } from '../../pages/protocol-view/protocolStoreProvider.tsx';
import { Input } from '../input.tsx';
import { FormMarkerList } from './formMarkerList.tsx';


interface Props {
    positionIndex: number;
    isReadOnly: boolean;
    onMenuOpenClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onDragStart: (positionIndex: number) => void;
    onDrop: (positionIndex: number) => void;
}

export function VisualInspectionPosition({
    positionIndex,
    isReadOnly,
    onMenuOpenClick,
    onDragStart,
    onDrop,
}: Props) {

    const protocol = useProtocolStore(state => state.protocol);
    const setPositionField = useProtocolStore(state => state.setPositionField);
    const positionSelection = useProtocolStore(state => state.positionSelection);
    const setPositionSelection = useProtocolStore(state => state.setPositionSelection);


    function handleSelect() {
        setPositionSelection({ positionIdx: positionIndex });
    }


    if (!protocol) return null;
    const position = protocol.positions[positionIndex];
    const isActive = positionIndex === positionSelection?.positionIdx;
    return (
        <>
            <tr
                className={`${isActive && 'highlight--selected'}`}
                draggable={!isReadOnly}
                onClick={handleSelect}
                onDragStart={() => onDragStart(positionIndex)}
                onDragOver={e => e.preventDefault()}
                onDrop={() => onDrop(positionIndex)}
            >
                <td>
                    <Input
                        type='number'
                        value={position.positionNumber}
                        onChange={(e) => { setPositionField(positionIndex, 'positionNumber', e.target.value) }}
                        onFocus={handleSelect}
                        readOnly={isReadOnly}
                        style={{ pointerEvents: isReadOnly ? 'none' : 'auto' }} //Let clicks pass through when readonly
                    />
                </td>
                <td colSpan={8}>
                    <input
                        type='text'
                        value={position.description ?? ''}
                        onChange={(e) => { setPositionField(positionIndex, 'description', e.target.value) }}
                        onFocus={handleSelect}
                        readOnly={isReadOnly}
                        style={{ pointerEvents: isReadOnly ? 'none' : 'auto' }} //Let clicks pass through when readonly
                    />
                </td>
                <td>
                    <button
                        className='td__menu-button'
                        onClick={onMenuOpenClick}
                        onFocus={handleSelect}>
                        &#8942;
                    </button>
                </td>
            </tr>

            {position.markers.length > 1 &&
                <FormMarkerList
                    position={position}
                    positionIdx={positionIndex}
                    positionSelection={positionSelection}
                    setPositionSelection={setPositionSelection}
                    onMenuOpenClick={onMenuOpenClick}
                />
            }
        </>
    )
}
